module.exports = __webpack_public_path__ + "img/max.39ce2fa3.jpg";